import { useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { Field } from "../FormField";

export const JobTab = ({ emp, set, canEditRoles }) => {
  const [deps, setDeps] = useState([]);
  useEffect(() => { api.get("/departments").then((r) => setDeps(r.data)); }, []);
  const names = deps.map((d) => d.name);

  return (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <Field label="Employee code" value={emp.employee_code} onChange={set("employee_code")} testId="detail-employee-code" />
    <div>
      <label className="text-sm font-semibold text-stone-700">Department</label>
      <select value={emp.department || ""} onChange={set("department")} data-testid="detail-department"
        className="mt-1 w-full min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white">
        <option value="">— Select department —</option>
        {emp.department && !names.includes(emp.department) && <option value={emp.department}>{emp.department}</option>}
        {names.map((n) => <option key={n} value={n}>{n}</option>)}
      </select>
    </div>
    <Field label="Designation" value={emp.designation} onChange={set("designation")} testId="detail-designation" />
    <Field label="Shift" value={emp.shift} onChange={set("shift")} testId="detail-shift" />
    <Field label="Date of joining" value={emp.date_of_joining} onChange={set("date_of_joining")} type="date" testId="detail-doj" />
    <div>
      <label className="text-sm font-semibold text-stone-700">Role</label>
      {canEditRoles ? (
        <select value={emp.role} onChange={set("role")} data-testid="detail-role" className="mt-1 w-full min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white">
          <option value="employee">Employee</option>
          <option value="hr_admin">HR/Admin</option>
          <option value="super_admin">Super Admin</option>
        </select>
      ) : (
        <select value={emp.role} onChange={set("role")} data-testid="detail-role" className="mt-1 w-full min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white" disabled={emp.role === "super_admin"}>
          {emp.role === "super_admin" ? <option value="super_admin">Super Admin (Owner)</option> : (
            <>
              <option value="employee">Employee</option>
              <option value="hr_admin">HR/Admin</option>
            </>
          )}
        </select>
      )}
    </div>
    <div>
      <label className="text-sm font-semibold text-stone-700">Status</label>
      <select value={emp.status} onChange={set("status")} data-testid="detail-status" className="mt-1 w-full min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white">
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </select>
    </div>
  </div>
  );
};
